import { Component, Input } from '@angular/core';

@Component({
  selector: 'modal',
  template: `
  <div class="modal fade right" [id]="name" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-full-height modal-right" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title w-100" id="myModalLabel">{{ title }}</h4>
        </div>
        <div class="modal-body">
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  </div>`,
  styles: [
    `.modal .modal-full-height {
      width: 250px;
    }`]
})

export class ModalComponent {
  @Input() public name: string = '';
  @Input() public title: string = '';
}
